import * as i0 from '@angular/core';
import { Injectable, Input, Inject, Component, NgModule } from '@angular/core';
import * as i8 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i9 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i10 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i11 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i12 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i13 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i1 from '@azavista/components/shared';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i7 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i14 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import { Subject, takeUntil } from 'rxjs';
import * as i4 from '@angular/common';
import * as i5 from '@angular/forms';
import * as i6 from '@ngx-translate/core';
function AzavistaFilterCriteriaComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dialogTitle);
  }
}
function AzavistaFilterCriteriaComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "MANAGE_FILTER"));
  }
}
function AzavistaFilterCriteriaComponent_div_5_mat_list_item_6_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 18);
  }
}
function AzavistaFilterCriteriaComponent_div_5_mat_list_item_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-list-item", 16);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_div_5_mat_list_item_6_Template_mat_list_item_click_0_listener() {
      const filter_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.filterSelected(filter_r4.id));
    });
    i0.ɵɵtemplate(1, AzavistaFilterCriteriaComponent_div_5_mat_list_item_6_span_1_Template, 1, 0, "span", 17);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("filter-item-selected", ctx_r0.isFilterSelected(filter_r4.id))("filter-item-updated", ctx_r0.isFilterUpdated(filter_r4.id));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isFilterUpdated(filter_r4.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(filter_r4.name);
  }
}
function AzavistaFilterCriteriaComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 12)(2, "azavista-flat-button", 9);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_div_5_Template_azavista_flat_button_click_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.addNewFilter());
    });
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵtext(4, "ADD_NEW");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "mat-list", 14);
    i0.ɵɵtemplate(6, AzavistaFilterCriteriaComponent_div_5_mat_list_item_6_Template, 4, 6, "mat-list-item", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.allFilters);
  }
}
function AzavistaFilterCriteriaComponent_div_7_div_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_div_7_div_1_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onDeleteSingleFilter(ctx_r0.data.filter.id));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFilterCriteriaComponent_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "mat-form-field", 26)(2, "input", 27);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function AzavistaFilterCriteriaComponent_div_7_div_1_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.data.filter.name, $event) || (ctx_r0.data.filter.name = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("input", function AzavistaFilterCriteriaComponent_div_7_div_1_Template_input_input_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onNameChanged($event.target.value));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, AzavistaFilterCriteriaComponent_div_7_div_1_button_4_Template, 3, 0, "button", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 4, "FILTER_NAME"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.data.filter.name);
    i0.ɵɵproperty("disabled", ctx_r0.data.filter.isTemporary);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isMultiMode);
  }
}
function AzavistaFilterCriteriaComponent_div_7_mat_error_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error")(1, "span", 13);
    i0.ɵɵtext(2, "NAME_MUST_CONTAIN_A_VALUE");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFilterCriteriaComponent_div_7_div_4_mat_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const operator_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", operator_r10.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", operator_r10.displayText, " ");
  }
}
function AzavistaFilterCriteriaComponent_div_7_div_4_azavista_input_field_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 38);
    i0.ɵɵlistener("valueChanged", function AzavistaFilterCriteriaComponent_div_7_div_4_azavista_input_field_6_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const item_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onValueChanged(item_r9, $event));
    })("autocompleteSearchTextChanged", function AzavistaFilterCriteriaComponent_div_7_div_4_azavista_input_field_6_Template_azavista_input_field_autocompleteSearchTextChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const item_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onAutocompleteSearchTextChanged(item_r9, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("aza-cmp-invisible", !ctx_r0.operatorHasValue(item_r9.operator));
    i0.ɵɵproperty("canEdit", !ctx_r0.data.filter.isTemporary)("fullWidth", true)("editMode", !ctx_r0.data.filter.isTemporary)("field", ctx_r0.getFieldForValues(item_r9.field))("options", ctx_r0.getFieldOptions(item_r9.field.id))("value", item_r9.value);
  }
}
function AzavistaFilterCriteriaComponent_div_7_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 30)(2, "azavista-input-field", 31);
    i0.ɵɵlistener("valueChanged", function AzavistaFilterCriteriaComponent_div_7_div_4_Template_azavista_input_field_valueChanged_2_listener($event) {
      const item_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onFieldChanged(item_r9, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 32)(4, "mat-select", 33);
    i0.ɵɵlistener("selectionChange", function AzavistaFilterCriteriaComponent_div_7_div_4_Template_mat_select_selectionChange_4_listener() {
      const item_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onOperatorChanged(item_r9));
    });
    i0.ɵɵtwoWayListener("valueChange", function AzavistaFilterCriteriaComponent_div_7_div_4_Template_mat_select_valueChange_4_listener($event) {
      const item_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      i0.ɵɵtwoWayBindingSet(item_r9.operator, $event) || (item_r9.operator = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(5, AzavistaFilterCriteriaComponent_div_7_div_4_mat_option_5_Template, 2, 2, "mat-option", 34);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, AzavistaFilterCriteriaComponent_div_7_div_4_azavista_input_field_6_Template, 1, 8, "azavista-input-field", 35);
    i0.ɵɵelementStart(7, "button", 36);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_div_7_div_4_Template_button_click_7_listener() {
      const item_r9 = i0.ɵɵrestoreView(_r8).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDeleteCriteriaItem(item_r9));
    });
    i0.ɵɵelementStart(8, "mat-icon");
    i0.ɵɵtext(9, "delete");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("field", ctx_r0.fieldSelectField)("value", ctx_r0.getFieldSelectFieldValue(item_r9))("editMode", !ctx_r0.data.filter.isTemporary)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.data.filter.isTemporary);
    i0.ɵɵtwoWayProperty("value", item_r9.operator);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r9.allOperators);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showValueField(item_r9));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r0.data.filter.isTemporary);
  }
}
function AzavistaFilterCriteriaComponent_div_7_span_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, "THERE_ARE_NO_FIELDS_AVAILABLE");
    i0.ɵɵelementEnd();
  }
}
function AzavistaFilterCriteriaComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, AzavistaFilterCriteriaComponent_div_7_div_1_Template, 5, 6, "div", 20)(2, AzavistaFilterCriteriaComponent_div_7_mat_error_2_Template, 3, 0, "mat-error", 1);
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵtemplate(4, AzavistaFilterCriteriaComponent_div_7_div_4_Template, 10, 9, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 23)(6, "azavista-flat-button", 11);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_div_7_Template_azavista_flat_button_click_6_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onAddCriteria());
    });
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵpipe(12, "uppercase");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, AzavistaFilterCriteriaComponent_div_7_span_13_Template, 2, 0, "span", 24);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.hideFilterName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.nameIsEmpty);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.filter.criteria);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", (ctx_r0.data.filter == null ? null : ctx_r0.data.filter.isTemporary) || ctx_r0.noFieldsAvailable);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 8, i0.ɵɵpipeBind1(11, 6, "ADD")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.noFieldsAvailable);
  }
}
function AzavistaFilterCriteriaComponent_azavista_button_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 39);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_azavista_button_21_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onDelete());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "uppercase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, i0.ɵɵpipeBind1(3, 1, "DELETE")));
  }
}
let AzavistaFilterCriteriaService = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaService {
    getFirstAvailableOperator(operatorWithAvailability) {
      const firstAvailableOperatorWithAvailability = operatorWithAvailability[0];
      if (firstAvailableOperatorWithAvailability) {
        return firstAvailableOperatorWithAvailability.name;
      } else {
        return null;
      }
    }
    static {
      this.ɵfac = function AzavistaFilterCriteriaService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaFilterCriteriaService,
        factory: AzavistaFilterCriteriaService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaFilterCriteriaService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFilterCriteriaComponent = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaComponent {
    constructor(sharedSvc, filterCriteriaSvc, dialogRef, data) {
      this.sharedSvc = sharedSvc;
      this.filterCriteriaSvc = filterCriteriaSvc;
      this.dialogRef = dialogRef;
      this.data = data;
      this.deleted = new Subject();
      this.nameIsEmpty = false;
      this.canSave = true;
      this.isMultiMode = false;
      this.updatedIds = [];
      this.createdIds = [];
      this.deletedIds = [];
      this.noFieldsAvailable = false;
      // showValueField = true;
      this.criteriaAutoTagAutoIncrementValue = 0;
      this.hiddenCriteriaItems = new Set();
      this.destroyed$ = new Subject();
    }
    ngOnInit() {
      this.data = this.prepareData(this.data);
      this.dialogTitle = this.data.dialogTitle;
      this.initialName = this.data.filter ? this.data.filter.name : '';
      this.nameIsEmpty = !!this.data.filter && this.isFalsy(this.initialName);
      this.setCanSave();
      this.fieldSelectField = {
        id: 'field_selector',
        name: 'field_selector',
        editable: true,
        builtin: false,
        category: '',
        label: '',
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */
      };
      if (this.autocompleteInputFieldFilterResultSubject) {
        this.autocompleteInputFieldFilterResultSubject.asObservable().pipe(takeUntil(this.destroyed$)).subscribe(filterResult => this.processAutocompleteInputFieldFilterResult(filterResult));
      }
    }
    prepareData(data) {
      let newData = this.sharedSvc.clone(data);
      newData.allFields = this.sharedSvc.convertFieldsForAdvancedFilter(newData.allFields);
      // Reference fields
      if (newData.allFilters) {
        for (const filter of newData.allFilters) {
          if (filter.criteria) {
            for (const criteria of filter.criteria) {
              if (criteria.field) {
                criteria.field = newData.allFields.find(x => x.id === criteria.field.id);
              }
            }
          }
        }
        // Remove all criteria which do not have fields
        // This could happen if criteria is saved but later filter is deleted
        // In such cases data.allFields will not contain field with criteria field id
        newData.allFilters = newData.allFilters.filter(x => x.criteria.every(y => !!y.field));
      }
      if (newData.searchParams) {
        // Existing filter is provided as search params - convert and set it to filter
        newData.filter.criteria = this.sharedSvc.searchParamsToCriteria(data.searchParams, data.allFields);
      }
      if (newData.filter && newData.filter.criteria) {
        // Remove all criteria which do not have fields
        // This could happen if criteria is saved but later filter is deleted
        // In such cases data.allFields will not contain field with criteria field id
        newData.filter.criteria = newData.filter.criteria.filter(x => x.field);
        for (const criteria of newData.filter.criteria) {
          criteria.field = newData.allFields.find(x => x.id === criteria.field.id);
        }
      }
      if (newData.allFilters) {
        this.isMultiMode = true;
        newData.allFilterNames = newData.allFilters.map(x => x.name);
      }
      newData.allFields = this.sharedSvc.getNonVisibleFieldsFromFilterCriteriaData(newData.allFilters, newData.filter, newData.allFields);
      this.noFieldsAvailable = newData.allFields.length === 0;
      this.convertAutocompleteFieldsValues(newData);
      this.assignTagsToAllCriteria(newData);
      return newData;
    }
    convertAutocompleteFieldsValues(data) {
      // The data provided only contains the selected id in the value property for autocomplete fields
      // Autocomplete fields cannot have as value simple string so we want to create real autocomplete field value
      // with selected item the one which is provided but also show its name, not the id
      const allCriteria = this.getAllCriteria(data);
      const autocompleteFieldsCriteria = allCriteria.filter(x => x.field.component === "autocomplete" /* FieldComponentType.autocomplete */);
      for (const criteria of autocompleteFieldsCriteria) {
        const criteriaIdValue = criteria.value;
        this.setCriteriaDefaultAutocompleteInputFieldValue(criteria);
        const criteriaAutocompleteFieldValue = criteria.value;
        const mapItem = this.autocompleteInputFieldsValueIdNameMapping?.find(x => x.id === criteriaIdValue);
        if (mapItem) {
          criteriaAutocompleteFieldValue.selected = mapItem;
        } else {
          criteriaAutocompleteFieldValue.selected = {
            id: criteriaIdValue,
            name: criteriaIdValue
          };
        }
      }
    }
    getAllCriteria(data) {
      const result = [];
      if (data.filter?.criteria) {
        for (const item of data.filter.criteria) {
          result.push(item);
        }
      }
      if (data.allFilters) {
        for (const filter of data.allFilters) {
          if (filter.criteria) {
            for (const item of filter.criteria) {
              result.push(item);
            }
          }
        }
      }
      return result;
    }
    assignTagsToAllCriteria(data) {
      const allCriteria = this.getAllCriteria(data);
      for (const criteria of allCriteria) {
        criteria.tag ||= this.createNextCriteriaTag();
      }
    }
    processAutocompleteInputFieldFilterResult(filterResult) {
      const criteria = this.data.filter.criteria.find(x => x.tag === filterResult.tag);
      if (!criteria) {
        // This criteria was removed (probably the user clicked on "Delete" button while the response from the server was awaited)
        return;
      }
      const autocompleteFieldValue = criteria.value;
      autocompleteFieldValue.filteredItems = filterResult.filteredValues;
    }
    getFieldOptions(fieldId) {
      return this.sharedSvc.getFieldOptions(fieldId, this.data.fieldsOptions);
    }
    getFieldForValues(field) {
      const clonedField = this.sharedSvc.clone(field);
      this.sharedSvc.convertFieldEnumToArray(clonedField, "default" /* FieldComponentType.default */);
      return clonedField;
    }
    onFieldChanged(item, args) {
      item.field = args.value;
      // TODO: Changing field value from code does not have effect - we must reinitialize the field
      //       which is made below with this.sharedSvc.executeOnNextLoop
      // If field value always requires object (like autocomplete) we must provide it instead of null, which will cause exceptions/errors
      // TODO: Maybe we can create item.initialValue and use its clone here ?
      item.value = this.sharedSvc.getDefaultValueForField(item.field);
      // Refresh operators availability based on the field
      item.allOperators = this.sharedSvc.getAllOperatorsByField(item.field);
      const selected = item.allOperators.find(x => x.name === item.operator);
      if (!selected) {
        // Previous operator selection is not available for the new field
        // Find first available or clear it if available operator is not found
        item.operator = this.filterCriteriaSvc.getFirstAvailableOperator(item.allOperators);
      }
      this.markCurrentAsUpdated();
      const criteriaItem = item;
      this.sharedSvc.executeOnNextLoop(() => this.hiddenCriteriaItems.add(criteriaItem), () => this.hiddenCriteriaItems.delete(item));
    }
    showValueField(item) {
      return !this.hiddenCriteriaItems.has(item);
    }
    onOperatorChanged(item) {
      this.markCurrentAsUpdated();
    }
    operatorHasValue(operator) {
      return this.sharedSvc.operatorHasValue(operator);
    }
    filterSelected(id) {
      const filter = this.data.allFilters.find(x => x.id === id);
      this.data.filter = filter;
    }
    isFilterSelected(id) {
      if (!this.data.filter) {
        return false;
      }
      return this.data.filter.id === id;
    }
    isFilterUpdated(id) {
      return this.updatedIds.indexOf(id) >= 0 || this.createdIds.indexOf(id) >= 0;
    }
    filterUpdated(id) {
      if (this.createdIds.indexOf(id) === -1) {
        this.sharedSvc.addIfDoesNotExist(id, this.updatedIds);
      }
    }
    addNewFilter() {
      const newFilter = {
        criteria: [],
        name: this.getNewFilterName(),
        id: this.getNewFilterId()
      };
      this.data.allFilterNames = this.data.allFilters.map(x => x.name);
      this.createdIds.push(newFilter.id);
      this.data.allFilters.push(newFilter);
      if (this.data.allFilters.length === 1) {
        this.data.filter = this.data.allFilters[0];
      }
    }
    getNewFilterName() {
      const exsitingNames = this.data.allFilters.map(x => x.name);
      const filterName = this.sharedSvc.generateUniqueString('New filter', exsitingNames);
      return filterName;
    }
    getNewFilterId() {
      const existingIds = this.data.allFilters.map(x => x.id);
      const filterId = this.sharedSvc.generateUniqueString('autoid', existingIds);
      return filterId;
    }
    markCurrentAsUpdated() {
      if (!this.data.filter) {
        return;
      }
      if (this.createdIds.indexOf(this.data.filter.id) === -1) {
        this.sharedSvc.addIfDoesNotExist(this.data.filter.id, this.updatedIds);
      }
    }
    onNameChanged(name) {
      this.nameIsEmpty = this.isFalsy(name);
      this.markCurrentAsUpdated();
      this.setCanSave();
    }
    onValueChanged(item, change) {
      // Don't set value for autocomplete fields
      const fieldType = this.sharedSvc.getFieldTypeFromField(item.field);
      if (fieldType === 'virtual-autocomplete') {
        // We should not change the autocomplete field values (we use [value]="item.value" in the template)
        // because it causes issues when overriding current value
        // We will set the value to dedicated property
        item.autocompleteInputFieldChangedValue = change.value;
      } else {
        // This is a field with simpe value
        item.value = change.value;
      }
      this.markCurrentAsUpdated();
    }
    onAutocompleteSearchTextChanged(item, autocompleteSearchTextChangedData) {
      if (this.autocompleteInputFieldSearchTextChangedSubject) {
        const fieldWithValue = {
          field: item.field,
          value: item.value
        };
        this.autocompleteInputFieldSearchTextChangedSubject.next({
          fieldWithValue,
          autocompleteSearchTextChangedData,
          tag: item.tag
        });
      }
    }
    onDeleteCriteriaItem(item) {
      const index = this.data.filter.criteria.findIndex(x => x === item);
      if (index >= 0) {
        this.data.filter.criteria.splice(index, 1);
      }
      this.markCurrentAsUpdated();
    }
    onAddCriteria() {
      const field = this.data.allFields[0];
      const allOperators = this.sharedSvc.getAllOperatorsByField(field);
      const criteria = {
        field: field,
        allOperators: allOperators,
        operator: this.filterCriteriaSvc.getFirstAvailableOperator(allOperators),
        value: null,
        tag: this.createNextCriteriaTag()
      };
      // If the field type is such it needs object in the value - provide it
      if (field.component === "autocomplete" /* FieldComponentType.autocomplete */) {
        this.setCriteriaDefaultAutocompleteInputFieldValue(criteria);
      }
      this.data.filter.criteria.push(criteria);
      this.markCurrentAsUpdated();
    }
    createNextCriteriaTag() {
      this.criteriaAutoTagAutoIncrementValue++;
      return `filter-criteria-tag-${this.criteriaAutoTagAutoIncrementValue}`;
    }
    setCriteriaDefaultAutocompleteInputFieldValue(criteria) {
      criteria.value = this.sharedSvc.createDefaultAutocompleteInputFieldValue();
    }
    onClearAllCriterias() {
      this.data.filter.criteria = [];
      this.markCurrentAsUpdated();
    }
    onCancel() {
      this.dialogRef.close();
    }
    onDelete() {
      this.deleted.next(this.data.filter);
    }
    onDeleteSingleFilter(id) {
      const index = this.data.allFilters.findIndex(x => x.id === id);
      if (index >= 0) {
        if (this.createdIds.indexOf(id) === -1) {
          // Not previously created (filter existed) - add it to deleted ids
          this.sharedSvc.addIfDoesNotExist(id, this.deletedIds);
        }
        this.sharedSvc.removeIfExists(id, this.createdIds);
        this.sharedSvc.removeIfExists(id, this.updatedIds);
        this.data.allFilters.splice(index, 1);
        if (this.data.allFilters.length) {
          this.data.filter = this.data.allFilters[0];
        } else {
          this.data.filter = null;
        }
      }
    }
    cleanUpCriteria() {
      if (!this.isMultiMode) {
        this.data.filter.criteria = this.data.filter.criteria.filter(x => !!x.operator);
        this.data.filter.criteria.forEach(x => delete x.tag);
      } else {
        for (const filter of this.data.allFilters) {
          filter.criteria = filter.criteria.filter(x => !!x.operator);
          filter.criteria.forEach(x => delete x.tag);
        }
      }
    }
    onSave() {
      this.cleanUpCriteria();
      if (!this.isMultiMode && !this.data.allowEmptyFilter && this.data.filter.criteria.length === 0) {
        // All criteria is removed from the single filter - delete it instead of saving the changes
        this.onDelete();
        return;
      }
      if (this.nameIsEmpty) {
        return;
      }
      if (this.isMultiMode) {
        // Manage all filters without criteria
        const noCriteriaFilters = this.data.allFilters.filter(x => !x.criteria || x.criteria.length === 0);
        for (const noCriteriaFilter of noCriteriaFilters) {
          if (this.createdIds.indexOf(noCriteriaFilter.id) >= 0) {
            // This filter was created - remove it from created ids
            this.sharedSvc.removeIfExists(noCriteriaFilter.id, this.createdIds);
          } else {
            // This filter was updated - remove if from updated and add it to deleted
            this.sharedSvc.removeIfExists(noCriteriaFilter.id, this.updatedIds);
            this.sharedSvc.addIfDoesNotExist(noCriteriaFilter.id, this.deletedIds);
          }
        }
        for (const filter of this.data.allFilters) {
          this.setNullValueToFalseForCheckboxFields(filter);
        }
        // Pass also createdIds and deletedIds
        const multiResult = {
          filterCriteriaData: this.data,
          updatedIds: this.updatedIds,
          createdIds: this.createdIds,
          deletedIds: this.deletedIds
        };
        this.dialogRef.close(multiResult);
      } else {
        // const singleResult: ISingleFilterCriteriaResult = {
        //     filter: this.data.filter,
        //     searchParams: flatSearchToRecursive(this.data.filter.criteria as any, 'name')
        // };
        // TODO: Pass an object containing more info like SearchParams
        const clonedFilter = this.sharedSvc.clone(this.data.filter);
        this.setNullValueToFalseForCheckboxFields(clonedFilter);
        this.setEmptyArrayForNullArrayFields(clonedFilter);
        this.convertAutocompleteFieldsValue(clonedFilter);
        this.dialogRef.close(clonedFilter);
      }
    }
    convertAutocompleteFieldsValue(filter) {
      filter.criteria.forEach(x => {
        const isAutocomplete = this.sharedSvc.getFieldTypeFromField(x.field) === 'virtual-autocomplete';
        if (isAutocomplete) {
          if (x.autocompleteInputFieldChangedValue !== undefined) {
            // The value has been changed
            x.value = x.autocompleteInputFieldChangedValue;
            delete x.autocompleteInputFieldChangedValue;
          } else {
            // The value has not been changed - use existing one
            const autocompleteValue = x.value;
            x.value = autocompleteValue.selected?.id || null;
          }
        }
      });
    }
    setEmptyArrayForNullArrayFields(filter) {
      filter.criteria.forEach(x => {
        if (!x?.value) {
          const fieldType = this.sharedSvc.getFieldTypeFromField(x?.field);
          if (fieldType === 'multi-select' || fieldType === 'select') {
            x.value = [];
          }
        }
      });
    }
    setNullValueToFalseForCheckboxFields(filter) {
      filter.criteria.forEach(x => {
        if (this.sharedSvc.getFieldTypeFromField(x?.field) === 'boolean' && x?.value === null) {
          x.value = false;
        }
      });
    }
    isFalsy(value) {
      const hasValue = value && value.trim();
      return !hasValue;
    }
    setCanSave() {
      this.canSave = !this.nameIsEmpty;
    }
    getFieldSelectFieldValue(item) {
      return {
        items: this.data.allFields,
        selected: item.field || null,
        displayProperty: 'label'
      };
    }
    ngOnDestroy() {
      this.destroyed$.next();
      this.destroyed$.complete();
    }
    static {
      this.ɵfac = function AzavistaFilterCriteriaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(AzavistaFilterCriteriaService), i0.ɵɵdirectiveInject(i3.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFilterCriteriaComponent,
        selectors: [["ng-component"]],
        inputs: {
          autocompleteInputFieldSearchTextChangedSubject: "autocompleteInputFieldSearchTextChangedSubject",
          autocompleteInputFieldFilterResultSubject: "autocompleteInputFieldFilterResultSubject",
          autocompleteInputFieldsValueIdNameMapping: "autocompleteInputFieldsValueIdNameMapping"
        },
        standalone: false,
        decls: 27,
        vars: 22,
        consts: [["mat-dialog-title", "", 1, "aza-cmp-dialog-title"], [4, "ngIf"], ["mat-dialog-content", "", 1, "main-container", "aza-cmp-dialog-content"], [1, "filters-list-container"], ["class", "aza-cmp-flex-column", 4, "ngIf"], ["mat-dialog-actions", "", 1, "filter-actions", "aza-cmp-flex-row", "aza-cmp-content-space-between", "aza-cmp-dialog-actions"], [1, "clear-all"], ["mat-stroked-button", "", "color", "primary", 3, "click", "disabled"], [1, "other-actions", "aza-cmp-flex-row"], ["color", "primary", 3, "click"], ["color", "warn", 3, "click", 4, "ngIf"], ["color", "primary", 3, "click", "disabled"], [1, "add-new-filter-container"], ["translate", ""], [1, "filters-list"], ["class", "cursor-hand", 3, "filter-item-selected", "filter-item-updated", "click", 4, "ngFor", "ngForOf"], [1, "cursor-hand", 3, "click"], ["class", "filter-updated-mark", 4, "ngIf"], [1, "filter-updated-mark"], [1, "aza-cmp-flex-column"], ["class", "filter-name-container aza-cmp-flex-row", 4, "ngIf"], [1, "filters-container", "aza-cmp-flex-column"], [4, "ngFor", "ngForOf"], [1, "add-criteria", "aza-cmp-flex-row"], ["translate", "", 4, "ngIf"], [1, "filter-name-container", "aza-cmp-flex-row"], [1, "aza-cmp-full-width"], ["matInput", "", 3, "ngModelChange", "input", "ngModel", "disabled", "placeholder"], ["mat-icon-button", "", "color", "warn", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "color", "warn", 3, "click"], [1, "criteria-container", "aza-cmp-grid"], [3, "valueChanged", "field", "value", "editMode", "fullWidth"], [1, "criteria-operator", "aza-cmp-min-small-width"], [3, "selectionChange", "valueChange", "disabled", "value"], [3, "value", 4, "ngFor", "ngForOf"], [3, "canEdit", "fullWidth", "editMode", "field", "options", "value", "aza-cmp-invisible", "valueChanged", "autocompleteSearchTextChanged", 4, "ngIf"], ["mat-icon-button", "", "color", "warn", 3, "click", "disabled"], [3, "value"], [3, "valueChanged", "autocompleteSearchTextChanged", "canEdit", "fullWidth", "editMode", "field", "options", "value"], ["color", "warn", 3, "click"]],
        template: function AzavistaFilterCriteriaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0);
            i0.ɵɵtemplate(1, AzavistaFilterCriteriaComponent_ng_container_1_Template, 2, 1, "ng-container", 1)(2, AzavistaFilterCriteriaComponent_ng_container_2_Template, 3, 3, "ng-container", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "div", 3);
            i0.ɵɵtemplate(5, AzavistaFilterCriteriaComponent_div_5_Template, 7, 1, "div", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div");
            i0.ɵɵtemplate(7, AzavistaFilterCriteriaComponent_div_7_Template, 14, 10, "div", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5)(9, "div", 6)(10, "button", 7);
            i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_Template_button_click_10_listener() {
              return ctx.onClearAllCriterias();
            });
            i0.ɵɵelementStart(11, "span");
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵpipe(14, "uppercase");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "div", 8)(16, "azavista-flat-button", 9);
            i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_Template_azavista_flat_button_click_16_listener() {
              return ctx.onCancel();
            });
            i0.ɵɵelementStart(17, "span");
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵpipe(20, "uppercase");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(21, AzavistaFilterCriteriaComponent_azavista_button_21_Template, 5, 5, "azavista-button", 10);
            i0.ɵɵelementStart(22, "azavista-button", 11);
            i0.ɵɵlistener("click", function AzavistaFilterCriteriaComponent_Template_azavista_button_click_22_listener() {
              return ctx.onSave();
            });
            i0.ɵɵelementStart(23, "span");
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵpipe(26, "uppercase");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dialogTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.dialogTitle);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isMultiMode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.data.filter);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", ctx.data.filter == null ? null : ctx.data.filter.isTemporary);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 12, i0.ɵɵpipeBind1(13, 10, "CLEAR_ALL")));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 16, i0.ɵɵpipeBind1(19, 14, "CANCEL")));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.data.isNew && !ctx.isMultiMode && !(ctx.data.filter == null ? null : ctx.data.filter.isTemporary));
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.data.filter == null ? null : ctx.data.filter.isTemporary);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 20, i0.ɵɵpipeBind1(25, 18, "SAVE")));
          }
        },
        dependencies: [i4.NgForOf, i4.NgIf, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i6.TranslateDirective, i7.AzavistaButtonComponent, i7.AzavistaFlatButtonComponent, i8.MatList, i8.MatListItem, i9.MatFormField, i9.MatError, i10.MatInput, i11.MatSelect, i11.MatOption, i12.MatIcon, i3.MatDialogTitle, i3.MatDialogActions, i3.MatDialogContent, i13.MatButton, i13.MatIconButton, i14.AzavistaInputFieldComponent, i4.UpperCasePipe, i6.TranslatePipe],
        styles: [".main-container[_ngcontent-%COMP%]{max-height:80vh}.criteria-container[_ngcontent-%COMP%]{grid-template-columns:1fr 1fr 1fr 0fr}.filters-container[_ngcontent-%COMP%]{max-height:60vh;overflow:auto}"]
      });
    }
  }
  return AzavistaFilterCriteriaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFilterCriteriaModule = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaModule {
    static {
      this.ɵfac = function AzavistaFilterCriteriaModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaFilterCriteriaModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, AzavistaButtonModule, MatListModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatIconModule, MatDialogModule, MatButtonModule, AzavistaInputFieldModule]
      });
    }
  }
  return AzavistaFilterCriteriaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaFilterCriteriaComponent, AzavistaFilterCriteriaModule };
